export const REACT_QUERY_KEYS = {
    VOD_DETAILS: 'vod-details',
    USER_REVISION: 'user-revision',
    LANGUAGE_KEY: 'language-load',
    SCREEN_KEY: 'screen-load',
    CHANNEL_LIST: 'channel-list',
    // Configuration keys
    CONFIGURATION: 'configuration',
    CONFIGURATION_VERSION: 'configuration-version',
    BASE_CONFIGURATION: 'base-configuration',
};
